export default __webpack_public_path__ + "static/media/cover1.d2899962.jpg";